import type { FC, SVGProps } from 'react';

export const HomeIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2002_5741)">
        <rect width="14" height="14" fillOpacity="0.01" fill="currentColor" />
        <g clipPath="url(#clip1_2002_5741)">
          <path
            fill="currentColor"
            d="M7.00061 0.307617C7.13057 0.307617 7.25509 0.35959 7.34729 0.451172L7.75256 0.855469L13.7897 6.88965C13.9786 7.07861 14.0835 7.33024 14.0836 7.5957C14.0841 7.72714 14.0586 7.85799 14.0084 7.97949C13.9583 8.10083 13.8846 8.211 13.7916 8.30371C13.6026 8.49277 13.3508 8.59766 13.0836 8.59766H12.4059V13.6865H1.59631V8.59766H0.932252C0.382252 8.59766 -0.0761468 8.1584 -0.0823968 7.6084C-0.0838819 7.47523 -0.0585233 7.34302 -0.00817809 7.21973C0.0422741 7.09628 0.117066 6.98376 0.211548 6.88965L6.65393 0.451172C6.74609 0.359622 6.87071 0.307672 7.00061 0.307617ZM1.22131 7.47266H2.72131V12.5615H5.12561V8.99902C5.12574 8.65389 5.40547 8.37414 5.75061 8.37402H8.25061C8.59585 8.37402 8.87548 8.65382 8.87561 8.99902V12.5615H11.2809V7.47266H12.7819L7.36292 2.05664L7.00256 1.69629L1.22131 7.47266ZM6.12561 9.37402V12.5615H7.87561V9.37402H6.12561Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2002_5741">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
        <clipPath id="clip1_2002_5741">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
